export class MathExtras {
  /**
   * Checks for overlap of collinear lines.
   *
   * @param aStartX - Start point of line A.
   * @param bEndX - End point of line A.
   * @param cStartX - Start point of line B.
   * @param dEndX - End point of line B.
   * @returns
   */
  public static getOverlap(aStartX: number, bEndX: number, cStartX: number, dEndX: number) {
    return bEndX - cStartX >= 0 && dEndX - aStartX >= 0;
  }
}
